import "es6-promise";

import { } from './classes/calendar-state';
import { fetchEvents } from './calendar-api-service';
import { reduce } from './calendar-reducer';
import * as Actions from './actions';

import { create } from '@adage/calendar';

import * as Rx from 'rx';
import * as redux from 'redux';

import { Store, createStore, applyMiddleware } from 'redux';
import { render } from 'react-dom';

//import * as aceCalendar from '@adage/ace-calendar';

import { Provider } from 'react-redux';

//import { appReducers, IAppState } from './reducers/index';
//import { loadLocalStorage } from './filter/actions/filter-actions';
//import { Router, Route, IndexRoute, Link, useRouterHistory, hashHistory } from 'react-router';
//import { createHashHistory } from 'history';

import thunk from 'redux-thunk';

import * as React from 'react'
import * as _ from 'lodash';
import * as moment from 'moment';
import CalendarContainer from './calendar-container';
import { IMainstreetEvent, IEventMonth, ICalendarState, IEventFilter, ICalendarSettings, defaultCalendarModel } from './classes';

let defaultState: ICalendarState<IMainstreetEvent> = {
    updating: false,
    specificDates: false,
    extendEvents: false,
    startDate: moment().startOf('month'),
    endDate: moment(moment().startOf('month')).add(11, 'month').endOf('month'),
    eventFilter: [],
    filterFunction: () => { return true; },
    events: [],
    currentDate: null,
    courseTypeFilter: [],
    eventTypeFilter: [],
    formatFilter: [],
    instructorFilter: '',
    locationFilter: '',
    showOnlyFreeEvent: false,
    dispatch: null,
    offset: 0,
    pageSize: 20,
    hasMoreEvents: false,
    showAllMonths: true
};

let calendarSettings: ICalendarSettings = {
    loadWrappingMonthDates: false,
    saveHistory: true
};

/**
 * Exposes the dispatch of the redux store for manual dispatches.
 */
export function calendarDispatch(): redux.Dispatch<ICalendarState<IMainstreetEvent>> {
    return _calendarState.dispatch;
}

/**
 * Exposes the current state of the calendar redux store.
 */
//    public static calendarState(): ICalendarState < IMainstreetEvent > {
//    return _calendarState.getState();
//}

//    /**
//     * Exposes the calendar store.
//     */
export function calendarStore(): redux.Store<ICalendarState<IMainstreetEvent>> {
    return _calendarState;
}

export function setDates(startDate: moment.Moment, endDate: moment.Moment) {
    _calendarState.dispatch(Actions.setDates(startDate, endDate));
}

let eventsCache = _.memoize(updateEvents,
    (state: ICalendarState<IMainstreetEvent>) => state.startDate.format('YYYY-MM-DD') + '~'
        + state.endDate.format('YYYY-MM-DD') + '~' + state.courseTypeFilter.toString()
        + '~' + state.eventTypeFilter.toString() + '~' + state.formatFilter.toString()
        + '~' + state.instructorFilter.toString() + '~' + state.locationFilter.toString()
        + '~' + state.showOnlyFreeEvent.toString() + '~' + state.offset);
createCalendarStore(defaultState, calendarSettings);

var appStore = calendarStore();

var app = React.createElement(Provider, { store: appStore }, React.createElement(CalendarContainer));
const appMount = document.getElementById('app-container');

render(app, appMount);

function getParameterByName(name) {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



/**
 * The backing observable that is shared by any subscribers of search updates
 */
var _calendarState: redux.Store<any>;
var _events: Rx.Subject<any[]>;
var _eventsByMonth: Array<IEventMonth<any>>;
var _loadEvents: Rx.Subject<any>;
var _calendarSettings: ICalendarSettings;
var _defaultCalendarModel: ICalendarState<IMainstreetEvent>;

export function createCalendarStore(calendarModel: ICalendarState<IMainstreetEvent> = defaultCalendarModel, calendarSettings: ICalendarSettings = { loadWrappingMonthDates: false, saveHistory: false }) {
    _calendarSettings = calendarSettings;
    _defaultCalendarModel = calendarModel;

    // Initialize an observable sequence of actions
    _events = new Rx.Subject<any[]>();
    _loadEvents = new Rx.Subject<any>();

    // Default initial state to the default search model
    let initialState = defaultCalendarModel;

    // Check the hash for an initial state
    if (window.location.hash) {
        const state = parseToObject(window.location.hash);

        if (Object.keys(state).some(_.identity)) {
            initialState = deserializeProps(state);
        }
    }

    _calendarState = redux.createStore(reduce, initialState);

    _loadEvents.flatMapLatest((state) => {
        //console.log(state);
        return eventsCache(_calendarState.getState()).then(events => {
            return events;
        }) as any;
    }).subscribe((events: Array<IMainstreetEvent>) => {
        _calendarState.dispatch({ type: Actions.ActionType.EventUpdated });

        const filteredEvents = _.filter(events, _calendarState.getState().filterFunction);

        _calendarState.dispatch({
            type: Actions.ActionType.UpdateEvents,
            value: events
        })
        _events.onNext(events);
    });

    // Create our search states observable; this is constructed by performing
    // a reduction on all of the actions.
    _calendarState.subscribe(() => {
        if (_calendarState.getState().updating)
            _loadEvents.onNext(_calendarState.getState());
    });

    // Trigger the initial load.
    setDates(_defaultCalendarModel.startDate, _defaultCalendarModel.endDate);

    // To ease unit testing, only subscribe to state updates when the $location/$rootScope services are supplied.
    if (window.location.hash.length > 1) {
        let urlState = parseToObject(window.location.hash);
        navigate(urlState, true);
    }

    if (_calendarSettings.saveHistory) {
        // Write state updates to the URL. Ran into a bug where directly modifying the window.location.hash
        // caused Angular to throw an infinite digest error. I was not able to figure out why this occurred, however, using
        // Angular's $location service to modify the hash seems to prevent the infinite digest from occurring.
        _calendarState
            .subscribe(() => {
                const currState = _calendarState.getState();
                if (currState.updating) {
                    const serialized = serializeProps(currState);
                    window.location.hash = encodeURI(serialized);
                }
            });

        // Emit navigation actions when the user navigates via the browser's fwd and back buttons.
        // $rootScope.$on('$locationChangeSuccess', (ev, url, oldUrl) => {
        //   var sameUrl = url === oldUrl;
        //   const rootCalendarUrl = oldUrl.indexOf('?') < 0 || oldUrl.indexOf(initialStartDate) > 0;
        //   const currState = _calendarState.getState();
        //   if (!currState.updating) {
        //     navigate($location.search(), !sameUrl && !rootCalendarUrl);
        //   }
        // });
    }
    //}
}

/**
 * Exposes the _searchStates observable.
 */

function navigate(urlState, shouldUpdate: boolean) {
    var state = deserializeProps(urlState);
    if (!shouldUpdate)
        return;
    // if (calendarState().getState().startDate.isSame(state.startDate)) {
    //   return;
    // } else {
    _calendarState.dispatch({
        type: Actions.ActionType.BrowserNavigated,
        value: { state, shouldUpdate }
    });
    // }
}

function updateEvents(state: ICalendarState<IMainstreetEvent>): Promise<Array<any>> {
    return fetchEvents(
        state.startDate.format('YYYY-MM-DD'), state.endDate.format('YYYY-MM-DD'),
        state.courseTypeFilter, state.eventTypeFilter, state.formatFilter, state.instructorFilter, state.locationFilter,
        state.showOnlyFreeEvent, state.offset, state.pageSize
    ).then((events) => {
        state.updating = false;
        return events;
    });
}

/**
 * Creates the serialized state object that gets passed to Angular's $location.search function. We
 * simply convert each property to it's serialized form
 */
function serializeProps(state: ICalendarState<IMainstreetEvent>): string {
    const urlState = Object.keys(_defaultCalendarModel)
        .filter(key => key !== 'events' && key !== 'eventFilter' && key !== 'updating')
        .reduce((acc, key) => {
            var value = JSON.stringify(state[key]);
            if (key == "startDate" || key == "endDate" || key == "currentDate") {
                value = moment(state[key]).format('YYYY-MM-DD');
            }
            const defaultValue = JSON.stringify(_defaultCalendarModel[key]);

            if (value === defaultValue) {
                return acc;
            }

            acc[key] = value;
            return acc;
        }, {} as { [key: string]: string });

    return JSON.stringify(urlState);
}

/**
 * Deserializes all properties from the url state and defaults search model values
 * to values from the defaultSearchModel.
 */
function deserializeProps(urlState): ICalendarState<IMainstreetEvent> {
    return Object.keys(_defaultCalendarModel).reduce((acc, key) => {
        if (key === "endDate"
            && typeof urlState[key] === 'undefined'
            && typeof _defaultCalendarModel[key] === 'undefined'
            && !moment(acc["startDate"]).isSame(moment(_defaultCalendarModel["startDate"]))
        ) {
            acc[key] = moment(acc["startDate"]).endOf('month');
        }
        else if (key === "endDate" || key === "startDate" || key === "currentDate") {
            acc[key] = getDateFromUrlOrDefault(urlState, key);
        }
        else {
            acc[key] = getValueFromUrlOrDefault(urlState, key);
        }
        return acc;
    }, {}) as ICalendarState<IMainstreetEvent>;
}

function getValueFromUrlOrDefault(urlState, key) {
    const urlValue = urlState[key];
    return typeof urlValue === 'undefined' ? _defaultCalendarModel[key] : JSON.parse(urlValue);
}

function getDateFromUrlOrDefault(urlState, key) {
    const urlValue = urlState[key];
    return typeof urlValue === 'undefined' ? moment(_defaultCalendarModel[key]) : moment(urlValue);
}

function parseToObject(hash: string): Object {
    return JSON.parse(decodeURI(hash.substr(1)));
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/calendar.tsx